import React, { useEffect, useState } from 'react';
import {
  Breadcrumb,
  Button,
  ConfigProvider,
  Form,
  Input,
  Space,
  Popconfirm,
  Collapse,
} from 'antd';
import {
  getRulesRequest,
  saveInfoPagesRequest,
} from '../requests/contactRequests';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import { HomeOutlined, SaveOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import plPL from 'antd/lib/locale/pl_PL';
import TextEditor from 'modules/layoutModule/components/TextEditor/TextEditor';
import { FieldData } from 'rc-field-form/lib/interface';
import copyToClipboard from 'helpers/copyToClipboard';

const { Panel } = Collapse;
const { TextArea } = Input;

const Rules = () => {
  const [isSaveButtonLoading, toggleButtonLoading] = useState(false);
  const [form] = Form.useForm();
  const [fields, setFields] = useState<FieldData[]>([]);
  const [loading, toggleLoading] = useState<boolean>(false);
  const [contentValue, setContentValue] = useState<string | undefined>('');

  const onSubmitForm = (values: any) => {
    toggleButtonLoading(true);
    saveInfoPagesRequest(values).then(() => toggleButtonLoading(false));
  };

  useEffect(() => {
    toggleLoading(true);

    getRulesRequest().then((response) => {
      toggleLoading(false);
      setFields([
        {
          name: ['id'],
          value: response.id,
        },
        {
          name: ['table1'],
          value: response.table1,
        },
        {
          name: ['table2'],
          value: response.table2,
        },
        {
          name: ['table3'],
          value: response.table3,
        },
        {
          name: ['table4'],
          value: response.table4,
        },
        {
          name: ['table5'],
          value: response.table5,
        },
      ]);
      setContentValue(response.content);
    });
  }, []);

  const validateMessages = {
    required: 'Proszę uzupełnić pole ${label}!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  const onContentEdit = (e: any) => {
    setFields([
      {
        name: ['content'],
        value: e,
      },
    ]);
  };

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Kontakt</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/rules">Regulamin i polityka cookies</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <div className="site-layout-background">
        <ConfigProvider locale={plPL}>
          <Form
            layout="vertical"
            validateMessages={validateMessages}
            onFinish={onSubmitForm}
            form={form}
            fields={fields}
          >
            <Form.Item name="id" hidden>
              <Input />
            </Form.Item>
            <Form.Item
              name="content"
              label="Treść"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              {/* @ts-ignore */}
              <TextEditor
                initialValue={contentValue}
                onChange={onContentEdit}
                disableGallery
              />
            </Form.Item>

            <div className="tables-collapse">
              <Collapse defaultActiveKey={[]}>
                <Panel header="Tabelka 1" key="1" forceRender>
                  <Form.Item name="table1" label="Tabelka 1">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#1')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#1
                  </Button>
                </Panel>
                <Panel header="Tabelka 2" key="2" forceRender>
                  <Form.Item name="table2" label="Tabelka 2">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#2')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#2
                  </Button>
                </Panel>
                <Panel header="Tabelka 3" key="3" forceRender>
                  <Form.Item name="table3" label="Tabelka 3">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#3')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#3
                  </Button>
                </Panel>
                <Panel header="Tabelka 4" key="4" forceRender>
                  <Form.Item name="table4" label="Tabelka 4">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#4')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#4
                  </Button>
                </Panel>
                <Panel header="Tabelka 5" key="5" forceRender>
                  <Form.Item name="table5" label="Tabelka 5">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#5')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#5
                  </Button>
                </Panel>
              </Collapse>
            </div>
            <Form.Item>
              <Space>
                <Popconfirm
                  title="Czy na pewno chcesz zapisać?"
                  placement="top"
                  onConfirm={() => form.submit()}
                  okText="Tak"
                  cancelText="Nie"
                >
                  <Button
                    type="primary"
                    icon={<SaveOutlined />}
                    loading={isSaveButtonLoading}
                  >
                    Zapisz
                  </Button>
                </Popconfirm>
              </Space>
            </Form.Item>
          </Form>
        </ConfigProvider>
      </div>
    </>
  );
};

export default Rules;
